import { createContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

/* Also read by the pre-paint script in index.html; keep both in sync. */
export const THEME_STORE_KEY = 'theme';

interface ThemeContextProps {
  preference: ThemePreference;
  resolvedTheme: ResolvedTheme;
  setPreference: (preference: ThemePreference) => void;
}

const ThemeContext = createContext<ThemeContextProps>({
  preference: 'system',
  resolvedTheme: 'dark',
  setPreference: () => {},
});

export default ThemeContext;
